<template>
	<div>
		<h3>CONTA BANCÁRIA DO ESTABELECIMENTO PARA RECEBÍVEIS</h3>

		<b-form class="mt-4">
			<b-form-row>
				<b-col cols="12">
					<input-component v-model="name" :required="true" label="Razão social" maxlength="255" name="name" />
				</b-col>
			</b-form-row>

			<b-form-row>
				<b-col cols="12" md="6">
					<input-component
						v-model="cnpj"
						:check="true"
						:mask="'##.###.###/####-##'"
						:required="true"
						label="CNPJ"
						maxlength="30"
						name="cnpj" />
				</b-col>

				<b-col cols="12" md="6">
					<input-component
						v-model="bank"
						:required="true"
						label="Nome do banco"
						maxlength="100"
						name="bank" />
				</b-col>
			</b-form-row>

			<b-form-row>
				<b-col cols="6" md="3">
					<input-component
						v-model="number"
						:required="true"
						label="Nº do Banco"
						maxlength="10"
						name="number" />
				</b-col>

				<b-col cols="6" md="3">
					<input-component v-model="agency" :required="true" label="Agência" maxlength="10" name="agency" />
				</b-col>

				<b-col cols="12" md="6">
					<input-component
						v-model="account"
						:required="true"
						label="Conta corrente (com dígito verificador)"
						maxlength="20"
						name="account" />
				</b-col>
			</b-form-row>
		</b-form>

		<p>Verifique se todos os dados preenchidos e a documentação anexada estão corretos.</p>
	</div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import InputComponent from "@/components/Form/Inputs/InputComponent";

export default {
	name: "BankFormComponent",
	components: { InputComponent },
	props: ["validationTrigger"],
	mounted() {
		if (this.$store.state.form.bankAccount.name) {
			this.$v.$touch();
		}

		this.$emit("setReadyToSubmit", this.isValid);
		this.$store.dispatch("updateStep", this.step);
	},
	watch: {
		isValid(value) {
			this.$emit("setReadyToSubmit", value);
		},
		validationTrigger() {
			this.$emit("setReadyToSubmit", this.isValid);
		},
	},
	computed: {
		isValid() {
			return !this.$v.$invalid;
		},
		name: {
			get() {
				return this.$store.state.form.bankAccount.name;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "name",
					value,
				});
			},
		},
		cnpj: {
			get() {
				return this.$store.state.form.bankAccount.cnpj;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "cnpj",
					value,
				});
			},
		},
		bank: {
			get() {
				return this.$store.state.form.bankAccount.bank;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "bank",
					value,
				});
			},
		},
		number: {
			get() {
				return this.$store.state.form.bankAccount.number;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "number",
					value,
				});
			},
		},
		agency: {
			get() {
				return this.$store.state.form.bankAccount.agency;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "agency",
					value,
				});
			},
		},
		account: {
			get() {
				return this.$store.state.form.bankAccount.account;
			},
			set(value) {
				this.$store.commit("setBankAccount", {
					key: "account",
					value,
				});
			},
		},
		step() {
			return this.$store.state.form.step;
		},
	},
	validations: {
		name: {
			required,
		},
		cnpj: {
			required,
			isValidCNPJ: function (cnpj) {
				return this.$root.isValidCNPJ(cnpj);
			},
		},
		bank: {
			required,
		},
		number: {
			required,
		},
		agency: {
			required,
		},
		account: {
			required,
		},
	},
};
</script>

<style lang="scss" scoped>
p {
	color: #c2c0bf !important;
	font-family: "Nunito Sans";
	font-size: 14px;
}
</style>
